import { FC } from 'react'
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@wellesley/ui'
import { Ellipsis } from 'lucide-react'

type MediaActionsMenuProps = {
  hideAlt: boolean
  isMediaHidden?: boolean
  contentWarning?: string | null
  onAltClick: () => void
  onToggleVisibility: (value: boolean) => void
}

const MediaActionsMenu: FC<MediaActionsMenuProps> = ({
  hideAlt,
  isMediaHidden,
  contentWarning,
  onAltClick,
  onToggleVisibility,
}) => {
  const hasShowHideItem = !!contentWarning

  if (hideAlt && !hasShowHideItem) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        onClick={(e) => e.stopPropagation()}
        className="left-xs top-xs size-s bg-alpha-black-20 absolute z-[1] flex cursor-pointer items-center justify-center rounded-full p-1.5 text-white backdrop-blur-[3px] focus:outline-none"
      >
        <Ellipsis size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        isPortal={true}
        onClick={(e) => e.stopPropagation()}
        className="min-w-[100px]"
      >
        {!hideAlt && (
          <DropdownMenuItem className="cursor-pointer" onClick={onAltClick}>
            ALT
          </DropdownMenuItem>
        )}
        {hasShowHideItem && (
          <DropdownMenuItem
            className="cursor-pointer"
            onClick={() => onToggleVisibility(!isMediaHidden)}
          >
            {isMediaHidden ? 'Show' : 'Hide'}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default MediaActionsMenu
